export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13978.f0345160.jpg";